<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>ZigZag Heading And CTA</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event,'ZigZagHacImage')"
            [blockData]="block.variables?.ZigZagHacImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="ZigZagHacImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event,'ZigZagHacHeading')"
            [blockData]="block.variables?.ZigZagHacHeading ?? ''"
            [placeholder]="headingPlaceholder"
            variable="ZigZagHacHeading"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event,'ZigZagHacImageHref')"
            [blockData]="block.variables?.ZigZagHacImageHref ?? ''"
            [placeholder]="imageHrefPlaceholder"
            variable="ZigZagHacImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHacImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.ZigZagHacImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event,'ZigZagHacImageAlt')"
            [blockData]="block.variables?.ZigZagHacImageAlt ?? ''"
            [placeholder]="imageAltPlaceholder"
            variable="ZigZagHacImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event,'ZigZagHacCtaLink')"
            [blockData]="block.variables?.ZigZagHacCtaLink ?? ''"
            [placeholder]="ctaLinkPlaceholder"
            variable="ZigZagHacCtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHacCtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.ZigZagHacCtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event,'ZigZagHacCtaText')"
            [blockData]="block.variables?.ZigZagHacCtaText ?? ''"
            [placeholder]="ctaTextPlaceholder"
            variable="ZigZagHacCtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            (handleOnChange)="onChange($event,'ZigZagHacText')"
            [blockData]="block.variables?.ZigZagHacText ?? ''"
            [placeholder]="textPlaceholder"
            variable="ZigZagHacText"
          >
          </app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div *ngIf="block.variables?.ZigZagHacImage" class="col-6">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.ZigZagHacImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.ZigZagHacImage)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.ZigZagHacImageAlt)"
            /></a>
          </div>
          <div class="col-6">
            <div class="row text-center">
              <div
                class="col-12"
                [innerHTML]="$safeNavigationMigration(block.variables?.ZigZagHacHeading)"
              ></div>
              <div
                class="col-12"
                [innerHTML]="$safeNavigationMigration(block.variables?.ZigZagHacText)"
              ></div>
              <div
                *ngIf="block.variables?.ZigZagHacCtaText"
                class="col-12 mt-3"
              >
                <a
                  target="_blank"
                  class="btn btn-primary"
                  [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.ZigZagHacCtaLink))"
                  role="button"
                  [innerHTML]="$safeNavigationMigration(block.variables?.ZigZagHacCtaText)"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
